"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELegalCapacity = void 0;
exports.ELegalCapacity = {
    majeur_capable: "majeur_capable",
    majeur_sous_protection: "majeur_sous_protection",
    mineur: "mineur",
};
